import React from "react";
import ImageResponsive from "./ImageResponsive";
import DetectionBox from "./DetectionBox";
import { getPercentStringFromFraction } from "../../lib/StringHelper";
import { ImageObjectDetections } from "../../types/ImageObjectDetections";
import "./Container60percent.css";

interface PredictionImageContainerProps {
  alt: string;
  src: string;
  detections?: ImageObjectDetections | null;
  threshold: number;
}

const PredictionImageContainer = (props: PredictionImageContainerProps) => {
  const { alt, src, detections, threshold } = props;
  return (
    <div className="container60percent">
      <ImageResponsive alt={alt} src={src} screenStyles={styles.image} />
      {detections &&
        detections.classes.map((detectionClass: number, index: number) => {
          const { labels, boxes, scores } = detections;

          const confidence = scores[index];
          if (confidence < threshold) return null;
          const name = labels[detectionClass];
          const box = boxes[index];
          const [y0, x0, y1, x1] = box;
          const computedStyle = {
            top: getPercentStringFromFraction(y0),
            left: getPercentStringFromFraction(x0),
            width: getPercentStringFromFraction(x1 - x0),
            height: getPercentStringFromFraction(y1 - y0),
          };
          return (
            <DetectionBox
              key={`${name}-${index}`}
              name={name}
              screenStyles={computedStyle}
            />
          );
        })}
    </div>
  );
};

const styles = {
  image: {
    position: "relative" as const,
    zIndex: 1,
  },
  detections: {
    position: "absolute" as const,
    zIndex: 2,
  },
};

export default PredictionImageContainer;
